import { jsx as _jsx } from "react/jsx-runtime";

function SvgScan() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.38 5.109C2.38 3.444 3.673 2 5.38 2h4.137a1 1 0 010 2H5.38c-.502 0-1 .447-1 1.109V7.58a1 1 0 11-2 0V5.109zM13.482 3a1 1 0 011-1h4.138c1.705 0 3 1.444 3 3.109V7.58a1 1 0 11-2 0V5.109c0-.662-.498-1.109-1-1.109h-4.138a1 1 0 01-1-1zM4.379 16.419a1 1 0 00-2 0v2.472c0 1.665 1.295 3.109 3 3.109h4.138a1 1 0 000-2H5.38c-.502 0-1-.447-1-1.109V16.42zm16.242-1a1 1 0 011 1v2.472c0 1.665-1.295 3.109-3 3.109h-4.138a1 1 0 110-2h4.138c.502 0 1-.447 1-1.109V16.42a1 1 0 011-1zM3 11a1 1 0 100 2h18a1 1 0 100-2H3z"
    }, void 0)
  }), void 0);
}

export default SvgScan;